import { Directive, Input, TemplateRef } from '@angular/core'

import { UiDataTableCellContext } from './ui-data-table.model'

@Directive({
    selector: '[uiTableCell]',
    standalone: true
})
export class UiTableCellDirective<T = unknown> {
    @Input() uiTableCell!: string

    constructor(public template: TemplateRef<UiDataTableCellContext<T>>) {}

    static ngTemplateContextGuard<T>(
        _dir: UiTableCellDirective<T>,
        ctx: unknown
    ): ctx is UiDataTableCellContext<T> {
        return true
    }
}
